import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';
import { getCountryCallingCode } from 'react-phone-number-input';
import styled from '@emotion/styled';

const Prefix = styled.span`
  font-size: 14px;
  min-width: 35px;
  margin-left: 8px;
  margin-right: 12px;
  text-align: left;
`;

const CountryLabel = ({ countryCode }) => {
  const FlagsComponent = countryCode ? Flags[countryCode] : React.Fragment;
  const prefix = getCountryCallingCode(countryCode);

  return (
    <>
      <FlagsComponent
        role="img"
        alt={countryCode}
        aria-hidden="true"
        data-cy="phoneInputCountryIconImg"
      />
      <Prefix>+{prefix}</Prefix>
    </>
  );
};

export default CountryLabel;
